<template>
  <fragment>
    <template v-if="submenu.sonMenu.length===0">
      <el-menu-item :index="submenu.path" :key="submenu.path" v-if="isLeftMenuItem(submenu)">
        <el-badge :value="getRedDotNum(submenu.redDotFc,submenu.type)!==0?getRedDotNum(submenu.redDotFc,submenu.type):''" class="item custom-badge">
          <i :class="submenu.icon"></i>
        </el-badge>
        <span slot="title">{{ submenu.title }}</span>
      </el-menu-item>
    </template>
    <template v-else>
      <el-submenu :index="submenu.path" v-if="isLeftMenuItem(submenu)">
        <template slot="title">
          <el-badge :value="getRedDotNum(submenu.redDotFc,submenu.type)!==0?getRedDotNum(submenu.redDotFc,submenu.type):''" class="item custom-badge">
            <i :class="submenu.icon"></i>
          </el-badge>
          <span slot="title">{{ submenu.title }}</span>
        </template>
        <sidebar-item
            v-for="child in submenu.sonMenu"
            :key="child.path"
            :submenu="child"/>
      </el-submenu>
    </template>
  </fragment>
</template>

<script>

import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "SidebarItem",
  props: ['submenu'],
  data() {
    return {
      userData:{},
      analysis: [],
      role:''
    }
  },
  created() {
    this.role = getDataInLocalStorage('role')
    this.userData = JSON.parse(getDataInLocalStorage('user'))
  },
  mounted() {

  },
  methods: {
    isLeftMenuItem(subItem) {
      return (subItem.role.length === 0 || subItem.role.includes(this.role));
    },
    getRedDotNum(redDotType,type) {
      if (redDotType) {
        if(type){
          return this.$store.getters[`dataStatus/${redDotType}`][type]
        }else{
          return this.$store.getters[`dataStatus/${redDotType}`]
        }
      }
      return 0
    },
    containsAny(array1, array2) {
      return array2.some(item => array1.includes(item));
    }
  }
}
</script>

<style scoped>
.custom-badge {
  position: relative;
  display: inline-block;
}


.custom-badge:deep(.el-badge__content) {
  top: 30%;
  /* 垂直居中 */
  right: 50%;
  /* 默认位置在右上角，这里需要调整 */
}
.red-dot{
  top: -5px;
  right: -5px;
}
.el-menu-item.is-active {
  background-color: rgb(217, 229, 246) !important;
  /*background-color: #5fa5ee !important;*/
  /*color: #111111;*/
  /*color: #3f9dfe;*/
  color: #1b3b81;
}


.el-menu-item:hover {
  background-color: rgb(201, 220, 246) !important;
}

.el-submenu :hover {
  /*background-color: rgb(201, 220, 246) !important;*/
}

/*.el-submenu .el-menu-item {*/
/*  background-color: rgb(217, 229, 246) !important;*/
/*  !*color: #111111 !important;*!*/
/*}*/

.el-submenu .el-menu-item:hover {
  background-color: rgb(217, 229, 246) !important;
}

.el-submenu .el-menu-item.is-active {
  /*background-color: rgb(217, 229, 246)!important;*/
  background-color: rgba(215, 229, 249, 0.81) !important;
  color: #386b94;
}
</style>
